import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {translate} from '@jsverse/transloco';

@Component({
    selector: 'app-permission-dialog',
    templateUrl: './permission-dialog.component.html',
    styleUrls: ['./permission-dialog.component.scss'],
    standalone: false
})
export class PermissionDialogComponent implements OnInit {

  title: string;
  message: string;
  closeButton: string = translate('DIALOG.CLOSE');
  name: string;


  constructor(@Inject(MAT_DIALOG_DATA) private data: any) {
  }

  ngOnInit(): void {
    this.title = this.data.title || this.title;
    this.message = this.data.message;
    this.name = this.data.name
  }
}
